import React from 'react'
import { object } from 'prop-types'
import SimpleList from '@/component/Primitive/SimpleList'

const ArticleStack = ({ articles }) => {
  const formattedArticles = articles.results?.map((article) => ({
    id: article._id,
    content: article.headline,
    href: article.fullUrlPath
  }))

  return <SimpleList listData={formattedArticles} />
}

ArticleStack.propTypes = {
  articles: object
}

export default ArticleStack
